// import { defaultLocale, localeOptions } from '../../constants/defaultValues'

import {

	SETTING_CREATE_MEMBERSHIP_CATEGORY,
	SETTING_CREATE_MEMBERSHIP_CATEGORY_SUCCESS,
	SETTING_UPDATE_MEMBERSHIP_CATEGORY,
	SETTING_UPDATE_MEMBERSHIP_CATEGORY_SUCCESS,
	SETTING_LOAD_MEMBERSHIP_CATEGORY,
	SETTING_LOAD_MEMBERSHIP_CATEGORY_SUCCESS,
	SETTING_DELETE_MEMBERSHIP_CATEGORY,
	SETTING_DELETE_MEMBERSHIP_CATEGORY_SUCCESS,

	LOGOUT_USER,
	SETTING_LOAD_MEMBERSHIP,
	SETTING_LOAD_MEMBERSHIP_SUCCESS,
	SETTING_CREATE_MEMBERSHIP,
	SETTING_CREATE_MEMBERSHIP_SUCCESS,
	SETTING_UPDATE_MEMBERSHIP,
	SETTING_UPDATE_MEMBERSHIP_SUCCESS,
	SETTING_DELETE_MEMBERSHIP,
	SETTING_DELETE_MEMBERSHIP_SUCCESS,
	// SETTING_LOAD_ALL_MEMBERSHIP_CUSTOMER,
	// SETTING_LOAD_ALL_MEMBERSHIP_CUSTOMER_SUCCESS,
	// SETTING_UPDATE_MEMBERSHIP_STATUS,
	// SETTING_UPDATE_MEMBERSHIP_STATUS_SUCCESS,

} from '../../actions';

const INIT_STATE = {

	membershipCategoryLoading: false,
	membershipLoading: false,
	membershipCategory: [],
	optionMembershipCategory: [],
	membership: [],
	optionMembership: [],
	// allMembershipCustomer: [],
	// optionAllMembershipCustomer: [],
	// dataCompanyInformation: null,

};

export default (state = INIT_STATE, action) => {
	switch (action.type) {

		case SETTING_LOAD_MEMBERSHIP_CATEGORY:
			return { ...state, membershipCategoryLoading: true, }
		case SETTING_LOAD_MEMBERSHIP_CATEGORY_SUCCESS:
			return {
				...state,
				membershipCategoryLoading: false,
				membershipCategory: action.payload,
				optionMembershipCategory: action.payloadlist
			}
		case SETTING_CREATE_MEMBERSHIP_CATEGORY:
			return { ...state, membershipCategoryLoading: true }
		case SETTING_CREATE_MEMBERSHIP_CATEGORY_SUCCESS:
			return { ...state, membershipCategoryLoading: false }
		case SETTING_UPDATE_MEMBERSHIP_CATEGORY:
			return { ...state, membershipCategoryLoading: true }
		case SETTING_UPDATE_MEMBERSHIP_CATEGORY_SUCCESS:
			return { ...state, membershipCategoryLoading: false }
		case SETTING_DELETE_MEMBERSHIP_CATEGORY:
			return { ...state, membershipCategoryLoading: true }
		case SETTING_DELETE_MEMBERSHIP_CATEGORY_SUCCESS:
			return { ...state, membershipCategoryLoading: false }
		case SETTING_LOAD_MEMBERSHIP:
			return { ...state, membershipLoading: true, }
		case SETTING_LOAD_MEMBERSHIP_SUCCESS:
			return {
				...state,
				membershipLoading: false,
				membership: action.payload,
				optionMembership: action.payloadlist
			}
		case SETTING_CREATE_MEMBERSHIP:
			return { ...state, membershipLoading: true }
		case SETTING_CREATE_MEMBERSHIP_SUCCESS:
			return { ...state, membershipLoading: false }
		case SETTING_UPDATE_MEMBERSHIP:
			return { ...state, membershipLoading: true }
		case SETTING_UPDATE_MEMBERSHIP_SUCCESS:
			return { ...state, membershipLoading: false }
		case SETTING_DELETE_MEMBERSHIP:
			return { ...state, membershipLoading: true }
		case SETTING_DELETE_MEMBERSHIP_SUCCESS:
			return { ...state, membershipLoading: false }
		// case SETTING_LOAD_ALL_MEMBERSHIP_CUSTOMER:
		// 	return { ...state, membershipLoading: true, }
		// case SETTING_LOAD_ALL_MEMBERSHIP_CUSTOMER_SUCCESS:
		// 	return {
		// 		...state,
		// 		membershipLoading: false,
		// 		allMembershipCustomer: action.payload,
		// 		optionAllMembershipCustomer: action.payloadlist
		// 	}
		// case SETTING_UPDATE_MEMBERSHIP_STATUS:
		// 	return { ...state, membershipLoading: true }
		// case SETTING_UPDATE_MEMBERSHIP_STATUS_SUCCESS:
		// 	return { ...state, membershipLoading: false }
		case LOGOUT_USER:
			return {
				...state,
				membershipCategoryLoading: false,
				membershipLoading: false,
				membershipCategory: [],
				optionMembershipCategory: [],
				membership: [],
				optionMembership: [],
				// allMembershipCustomer: [],
				// optionAllMembershipCustomer: [],
			};

		default: return { ...state };
	}
}